// GlidepathPieChart.js
import React from 'react';
//import DOMPurify from 'dompurify';
//import './GlidepathPieChart.css';

const GlidepathPieChart = () => (
  <div className="l-grid__row stacked-percent-portfolio-section justify-content-center circle-chart">
      <div className="chart-wrapper l-grid__column-large-6 l-grid__column-medium-12"></div>
      <div className="pie-legends l-grid__column-large-6 l-grid__column-medium-12 u-flex"></div>
  </div>
)

export default GlidepathPieChart;